import React, { useContext, useEffect } from "react";
import { Global, css } from "@emotion/react";
import { LoadContext } from "@providers/LoadProvider";
import UniversLightWoff from "@fonts/univers-light.woff";
import UniversLightWoff2 from "@fonts/univers-light.woff2";
import UniversRomanWoff from "@fonts/univers-roman.woff";
import UniversRomanWoff2 from "@fonts/univers-roman.woff2";
import UniversBoldWoff from "@fonts/univers-bold.woff";
import UniversBoldWoff2 from "@fonts/univers-bold.woff2";
import UniversBoldCondWoff from "@fonts/univers-bold-cond.woff";
import UniversBoldCondWoff2 from "@fonts/univers-bold-cond.woff2";
import OverpassLightWoff from "@fonts/overpass-light.woff";
import OverpassLightWoff2 from "@fonts/overpass-light.woff2";
import OverpassRegularWoff from "@fonts/overpass-regular.woff";
import OverpassRegularWoff2 from "@fonts/overpass-regular.woff2";
import OverpassBoldWoff from "@fonts/overpass-bold.woff";
import OverpassBoldWoff2 from "@fonts/overpass-bold.woff2";
import OverpassLotusHeadlineWoff from "@fonts/overpass-lotus-headlines.woff";
import OverpassLotusHeadlineWoff2 from "@fonts/overpass-lotus-headlines.woff2";

const GlobalFonts = () => {
  const { loadFonts } = useContext(LoadContext);

  useEffect(() => {
    if (typeof loadFonts === "function") {
      loadFonts({
        families: [
          "univers-light",
          "univers-roman",
          "univers-bold",
          "univers-bold-cond",
          "overpass-light",
          "overpass-regular",
          "overpass-bold",
          "overpass-lotus-headlines",
        ],
      });
    }
  }, [loadFonts]);

  return (
    <Global
      styles={css`
        @font-face {
          font-family: "univers-light";
          src: local("univers-light"), url(${UniversLightWoff2}) format("woff2"),
            url(${UniversLightWoff}) format("woff");
        }

        @font-face {
          font-family: "univers-roman";
          src: local("univers-roman"), url(${UniversRomanWoff2}) format("woff2"),
            url(${UniversRomanWoff}) format("woff");
        }

        @font-face {
          font-family: "univers-bold";
          src: local("univers-bold"), url(${UniversBoldWoff2}) format("woff2"),
            url(${UniversBoldWoff}) format("woff");
        }

        @font-face {
          font-family: "univers-bold-cond";
          src: local("univers-bold-cond"),
            url(${UniversBoldCondWoff2}) format("woff2"),
            url(${UniversBoldCondWoff}) format("woff");
        }

        @font-face {
          font-family: "overpass-light";
          src: local("overpass-light"),
            url(${OverpassLightWoff2}) format("woff2"),
            url(${OverpassLightWoff}) format("woff");
        }

        @font-face {
          font-family: "overpass-regular";
          src: local("overpass-regular"),
            url(${OverpassRegularWoff2}) format("woff2"),
            url(${OverpassRegularWoff}) format("woff");
        }

        @font-face {
          font-family: "overpass-bold";
          src: local("overpass-bold"), url(${OverpassBoldWoff2}) format("woff2"),
            url(${OverpassBoldWoff}) format("woff");
        }

        @font-face {
          font-family: "overpass-lotus-headlines";
          src: local("overpass-lotus-headlines"),
            url(${OverpassLotusHeadlineWoff2}) format("woff2"),
            url(${OverpassLotusHeadlineWoff}) format("woff");
        }
      `}
    />
  );
};

export default GlobalFonts;
